import React, { useEffect } from 'react';
import { ResultItem } from '../components/ResultItem';
import { useAuthStore } from '@/core/auth/auth.store';
import { useNavigate } from 'react-router-dom';
import { logoutSignos } from "@/core/api/sigma"
import { sendResults, sendResultsParams } from '@/core/api/sigma';
import { useState } from "react";
import { InfoModal } from '@/features/infoModal/pages/InfoModal';
import { vitalsData } from "@/shared/utils/vitalsData";
import { Footer } from '@/shared/components/layout/Footer';

//***preguntar como manejo este header

// const translations = {
//     'Heart Rate': 'Frecuencia Cardíaca',
//     'Pulse Rate': 'Frecuencia de Pulso',
//     'Breathing Rate': 'Frecuencia Respiratoria',
//     'Blood Pressure - Systolic': 'Presión Arterial - Sistólica',
//     'Blood Pressure - Diastolic': 'Presión Arterial - Diastólica',
//     'Systolic Blood Pressure': 'Presión Arterial Sistólica',
//     'Diastolic Blood Pressure': 'Presión Arterial Diastólica',
//     'Pulse Pressure': 'Presión de Pulso',
//     'Mean Arterial Pressure': 'Presión Arterial Media',
//     'Heart Rate Variability': 'Variabilidad de Frecuencia Cardíaca',
//     'Heart Rate Variability - SDNN': 'Variabilidad Cardíaca - SDNN',
//     'Heart Rate Variability - RMSSD': 'Variabilidad Cardíaca - RMSSD',
//     'Heart Rate Variability - pNN50': 'Variabilidad Cardíaca - pNN50',
//     'Heart Rate Variability - LF/HF': 'Variabilidad Cardíaca - LF/HF',
//     'Irregular Heartbeat Count': 'Latidos Irregulares',
//     'Stress Index': 'Índice de Estrés',
//     'Mental Stress Index': 'Índice de Estrés Mental',
//     'NuraLogix Mental Stress Index': 'Índice de Estrés Mental',
//     'Anxiety': 'Ansiedad',
//     'Cardiovascular Disease Risk': 'Riesgo Cardiovascular',
//     'Heart Attack Risk': 'Riesgo de Infarto',
//     'Stroke Risk': 'Riesgo de ACV',
//     'Diabetes Risk': 'Riesgo de Diabetes',
//     'Hypertension Risk': 'Riesgo de Hipertension',
//     'Hemoglobin': 'Hemoglobina',
//     'Hemoglobin A1c': 'Hemoglobina A1c',
//     'Total Cholesterol': 'Colesterol Total',
//     'HDL Cholesterol': 'Colesterol HDL',
//     'LDL Cholesterol': 'Colesterol LDL',
//     'Triglycerides': 'Trigliceridos',
//     'Body Mass Index': 'Índice de Masa Corporal',
//     'Body Shape Index': 'Índice de Forma Corporal',
//     'Waist Circumference': 'Circunferencia de Cintura',
//     'Waist-to-Height Ratio': 'Relación Cintura-Altura',
//     'Facial Age': 'Edad Facial',
//     'Facial Skin Age': 'Edad de la Piel',
//     'Oxygen Saturation': 'Saturacion de Oxigeno',
//     'Cardiac Workload': 'Carga Cardíaca',
//     'Vascular Capacity': 'Capacidad Vascular',
//     'NuraLogix Vitals Score': 'Puntuación de Signos Vitales',
//     'NuraLogix Mental Score': 'Puntuación Mental',
//     'NuraLogix Physical Score': 'Puntuación Física',
//     'NuraLogix Physiological Score': 'Puntuación Fisiológica',
//     'NuraLogix General Wellness Score': 'Puntuación de Bienestar General',
//     'NuraLogix Risks Score': 'Puntuación de Riesgos',
//     'Signal to Noise Ratio': 'Relación señal-ruido'//
// };

const unitTranslations = {
    'breaths / minute': 'respiraciones / minuto',
    'beats / minute': 'latidos / minuto',
    'seconds': 'segundos',
};

const groupTranslations = {
    vitals: {
        name: 'Signos Vitales',
        icon: 'icon_enlinea_signos-vitales'
    },
    physiological: {
        name: 'Fisiológico',
        icon: 'icon_enlinea_heart'
    },
    mental: {
        name: 'Mental',
        icon: 'icon_enlinea_mental'
    },
    physical: {
        name: 'Físico',
        icon: 'icon_enlinea_usuario'

    },
    generalRisks: {
        name: 'Riesgos generales',
        icon: 'icon_enlinea_en-observacin'
    },
    metabolicRisks: {
        name: 'Riesgos Metabólicos',
        icon: 'icon_enlinea_en-observacin'
    },
    bloodBiomarkers: {
        name: 'Biomarcadores',
        icon: 'icon_enlinea_heart'
    },
    overall: {
        name: 'General',
        icon: 'icon_enlinea_general'
    }
}

const translateMetric = (name) => vitalsData[name].traduccion || name;
const translateUnit = (unit) => unitTranslations[unit] || unit;

const VitalsResults = () => {
    const { user, logout } = useAuthStore();
    const navigate = useNavigate();
    // Estado para el modal
    const [modalData, setModalData] = React.useState({
        isOpen: false,
        title: '',
        icon: '',
        content: ''
    });
    const closeModal = () => setModalData({ ...modalData, isOpen: false });

    //Convertimos los puntos del API en un Array para poder manipularlos
    const apiPoints = Object.entries(user.results.points || {});

    //Primero mapeamos y enriquecemos los puntos con los datos de vitalsData
    const enrichedPoints = apiPoints
        .filter(([id, point]) => {
            const name = point?.info?.name;
            return name && name !== 'Signal to Noise Ratio';
        })
        .map(([id, point]) => {
            const pointName = point.info.name;
            const ref = vitalsData[pointName];

            return {
                id,
                point,
                orden: ref?.orden || 99,
                descripcion: ref?.descripcion || '',
                // Determinamos el grupo aquí mismo
                groupKey: (pointName === 'NuraLogix Vitals Score') ? 'vitals' :
                    (pointName === 'NuraLogix Physiological Score') ? 'physiological' :
                        (pointName === 'NuraLogix Mental Score') ? 'mental' :
                            (pointName === 'NuraLogix Physical Score') ? 'physical' :
                                (pointName === 'NuraLogix Risks Score') ? 'generalRisks' :
                                    (point.meta?.group || 'otros')
            };
        })
        //Ordenamos TODOS los puntos globalmente por el orden de vitalsData
        .sort((a, b) => a.orden - b.orden);

    //Ahora agrupamos los puntos ya ordenados
    const groupedPoints = enrichedPoints.reduce((acc, item) => {
        if (!acc[item.groupKey]) acc[item.groupKey] = [];

        acc[item.groupKey].push({
            id: item.id,
            point: item.point,
            orden: item.orden,
            descripcion: item.descripcion
        });

        return acc;
    }, {});

    useEffect(() => {
        const toBase64 = async (url: string): Promise<string> => {
            try {
                const res = await fetch(url);
                const blob = await res.blob();
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result as string);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            } catch {
                return url;
            }
        };

        const inlineUrlsInCSS = async (cssText: string, baseUrl: string): Promise<string> => {
            const matches = [...cssText.matchAll(/url\(['"]?([^'")\s]+)['"]?\)/g)];
            let result = cssText;
            for (const match of matches) {
                const rawUrl = match[1];
                if (rawUrl.startsWith('data:')) continue;
                const absolute = new URL(rawUrl, baseUrl).href;
                const b64 = await toBase64(absolute);
                result = result.replace(match[0], `url('${b64}')`);
            }
            return result;
        };

        const buildHTML = async (): Promise<string> => {
            let allCSS = '';
            for (const sheet of Array.from(document.styleSheets)) {
                try {
                    const rules = Array.from(sheet.cssRules || []);
                    const sheetCSS = rules.map(r => r.cssText).join('\n');
                    allCSS += await inlineUrlsInCSS(sheetCSS, sheet.href || window.location.href);
                } catch {
                    if (sheet.href) {
                        try {
                            const text = await fetch(sheet.href).then(r => r.text());
                            allCSS += await inlineUrlsInCSS(text, sheet.href);
                        } catch { /* cross-origin, skip */ }
                    }
                }
            }

            const clone = document.documentElement.cloneNode(true) as HTMLElement;
            clone.querySelectorAll('link[rel="stylesheet"], style').forEach(el => el.remove());
            const styleTag = document.createElement('style');
            styleTag.textContent = allCSS;
            clone.querySelector('head')?.appendChild(styleTag);
            clone.querySelectorAll('script').forEach(el => el.remove());
            clone.querySelectorAll('.btn-form-vitals, .footer-vitals').forEach(el => el.remove());

            const headerInfo = clone.querySelector('.header-vitals-info span');
            if (headerInfo) headerInfo.textContent = 'El chequeo se completó correctamente.';

            

            for (const img of Array.from(clone.querySelectorAll('img'))) {
                const src = img.getAttribute('src');
                if (src && !src.startsWith('data:')) {
                    img.setAttribute('src', await toBase64(new URL(src, window.location.href).href));
                }
            }

            for (const el of Array.from(clone.querySelectorAll('[style]'))) {
                const inlineStyle = el.getAttribute('style') || '';
                if (inlineStyle.includes('url(')) {
                    el.setAttribute('style', await inlineUrlsInCSS(inlineStyle, window.location.href));
                }
            }

            return '<!DOCTYPE html>\n' + clone.outerHTML;
        };

        buildHTML().then(async html => {
            //Envío de resultados a usuario y doctor cuando aplica
            console.log(html)
            console.log("await exportStaticHTML()")

            let email: string = user.email || user.xemail || null;
            if (!email || email == '') {
                if (!user?.detailLocalizadorCreated?.xemail || user?.detailLocalizadorCreated?.xemail == '') {
                    email = user.detailLocalizador.xemail || 'mvasquez2@sdsigma.com';   //Cuando es link por correo debe entrar por acá.
                } else {
                    email = user.detailLocalizadorCreated.xemail;
                }
            }

            if (email == 'mvasquez2@sdsigma.com') {
                console.log("No se encontró email del usuario, se usará email de pruebas para envío de resultados.");
                console.log(user);
            }

            const params: sendResultsParams = {
                results: html,
                snr: user.results.points.SNR.value,
                email: email,
                nlocaliza: user.nlocaliza || user.nlocalizaCreated,
                cpais: user.cpais
            }

            try {
                await sendResults(params);
            } catch (error) {
                console.error("Error enviando resultados:", error);
            }

        });

        (window as unknown as { exportStaticHTML: () => Promise<void> }).exportStaticHTML = async () => {
            const html = await buildHTML();
            const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'resultados-vitales.html';
            link.click();
            URL.revokeObjectURL(link.href);
        };
    }, []);

    const [loadingFinalizar, setLoadingFinalizar] = useState(false);

    const navigateFinalizar = () => {
        setLoadingFinalizar(true);

        setTimeout(() => {
            try {
                logout();
                logoutSignos();
            } catch (error) {
                console.error("Error saliendo de la sesión:", error);
            }

            navigate("/sessionfinished", { replace: true });

        }, 2000);
    };

    return (
        <div>
            <InfoModal
                isOpen={modalData.isOpen}
                onClose={closeModal}
                title={modalData.title}
                icon={modalData.icon}
            >
                <p>{modalData.content}</p>
            </InfoModal>

            <div className='container-vitals-results-contain'>
                <header>
                    <div className="header-vitals-results">
                        <span><i className="icon icon_enlinea_resultados"></i> Resultados de la medición</span>
                    </div>
                </header>

                <div className="header-vitals-info">
                    <span>
                        <i className="icon icon_enlinea_success-hover"></i> El chequeo se completó correctamente. Recibirás los resultados de la medición a tu correo electrónico.
                    </span>
                </div>
                <div className="container-vitals-results">
                    <div className="section-cards-vitals">

                        {/* Interpretación de Colores */}
                        <article className="card-vitals-result">
                            <div className="title-cards-info">
                                <span>Interpretación de colores</span>
                            </div>
                            <div className="content-cards-info">
                                <div className="card-vitals-info green">
                                    <div className="card-info-details">
                                        <i className="icon icon_enlinea_success"></i>
                                        <div className="color-info">
                                            <span className='color-info-green'>Verde</span>
                                            <span className='color-info-span'>Valor dentro del rango de referencia</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-vitals-info yellow">
                                    <div className="card-info-details">
                                        <i className="icon icon_enlinea_warning"></i>
                                        <div className="color-info">
                                            <span className='color-info-yellow'>Amarillo</span>
                                            <span className='color-info-span'>Ligeramente fuera del rango</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-vitals-info red">
                                    <div className="card-info-details">
                                        <i className="icon icon icon_enlinea_info"></i>
                                        <div className="color-info">
                                            <span className='color-info-red'>Rojo</span>
                                            <span className='color-info-span'>Fuera del rango de referencia</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>

                        {/* Seccion 1 - Signos Vitales */}
                        {/* <article className="card-vitals-result">
                        <div className="title-vitals-results">
                            <i className="icon icon_enlinea_success-hover"></i>
                            <span>Signos Vitales</span>
                        </div>

                        {Object.entries(user.results.points).map(([id, point]) => {
                            const numericValue = point.value !== null && point.value !== undefined ? parseFloat(point.value) : null;
                            const hasValue = numericValue !== null && !isNaN(numericValue);

                            return (
                                <ResultItem 
                                    key={id}
                                    label={translateMetric(point.info.name)} 
                                    value={hasValue ? numericValue.toFixed(2) : '-'}
                                    unit={translateUnit(point.info.unit || '-')} 
                                    percentage={calculatePercentage(point.value, point.meta.range?.min, point.meta.range?.max)}
                                />
                            );
                        })}
                    </article> */}

                        {Object.entries(groupedPoints).map(([groupKey, items]) => (
                            <article key={groupKey} className="card-vitals-result">
                                <div className="title-vitals-results">
                                    <i className={`icon ${groupTranslations[groupKey]?.icon || groupKey}`}></i>
                                    {/* Traducimos el título del grupo */}
                                    <span>{groupTranslations[groupKey].name || groupKey}</span>
                                </div>

                                {/* Renderizamos los items de este grupo específico */}
                                {items.map(({ id, point, descripcion }) => {
                                    const numericValue = point.value !== null && point.value !== undefined ? parseFloat(point.value) : null;
                                    const hasValue = numericValue !== null && !isNaN(numericValue);
                                    const label = translateMetric(point.info?.name || id);
                                    const iconClass = groupTranslations[groupKey].icon;

                                    return (
                                        <ResultItem
                                            key={id}
                                            label={label}
                                            value={hasValue ? numericValue.toFixed(2) : '--'}
                                            unit={translateUnit(point.info?.unit || '')}
                                            color={point.dial?.sections[point.dial.group - 1]?.bandColor}
                                            //Pasar la función para abrir el modal
                                            onClickInfo={() => setModalData({
                                                isOpen: true,
                                                title: label,
                                                icon: iconClass,
                                                content: descripcion
                                            })}
                                        />
                                    );
                                })}
                            </article>
                        ))}



                    </div>
                </div>

                <div className="panel-vitals">
                    <span className="text-panel-vitals">
                        <b>Aviso:</b> Estos valores son estimaciones y no sustituyen una revisión médica. Los rangos de referencia están basados en mediciones en reposo y la precisión puede variar según tu estado de salud, condición física y la calidad de la imagen.
                        <br /><br />
                        Si tienes dudas sobre tu salud, consulta a un profesional.
                    </span>
                </div>

                <div className="btn-form-vitals">
                    <button
                        type="button"
                        className="btn vitals-primary"
                        onClick={navigateFinalizar}
                        disabled={loadingFinalizar}
                    >
                        {loadingFinalizar ? (
                            <span className="btn-loading">
                                <img src="/img/cargando.gif" alt="Loading..." className="cargando-gif" />
                            </span>
                        ) : (
                            "Finalizar"
                        )}
                    </button>
                </div>
            </div>

            <Footer/>
        </div>
    );
};

export { VitalsResults };